module.exports = __webpack_public_path__ + "img/botabib2.cf44208a.png";